// @flow

const ACCOUNT_LOCKED: "account_locked" = "account_locked";
const UNAUTHORIZED_SCOPE: "unauthorized_scope" = "unauthorized_scope";
const ACCOUNT_UNCONFIRMED: "account_unconfirmed" = "account_unconfirmed";

const unprocessableEntityErrors = {
  invalid_file_size: "Sie können nur Dateien mit max. 15mb hochladen.",
  invalid_file_type:
    "Sie können nur Dateien in den folgenden Formaten hochladen: pdf, xlsx, xls, docx, doc, jpg, png",
  invalid_file_extension:
    "Sie können nur Dateien in den folgenden Formaten hochladen: pdf, xlsx, xls, docx, doc, jpg, png"
};

const autorizationErrors = {
  [ACCOUNT_LOCKED]:
    "Zu viele ungültige Anmeldeversuche. Bitte folgen Sie den Anweisungen in der E-Mail",
  [UNAUTHORIZED_SCOPE]:
    "Sie sind kein Teil des Nutzerkreises für dieses Portal. Sollten Sie hierzu Fragen haben, wenden Sie sich bitte an den Support.",
  [ACCOUNT_UNCONFIRMED]:
    "Sie haben Ihren Account noch nicht aktiviert. Bitte folgen Sie der Anleitung in der Bestätigung-E-Mail."
};

export const mapUnprocessableEntityError = (type: string) =>
  unprocessableEntityErrors[type] || type;

const statusErrors = (status: ?number) => {
  switch (status) {
    case 403:
      return `Sie sind aktuell nicht berechtigt, diese Aktion durchzuführen. Bitte ordnen Sie sich die Anfrage zu und wiederholen Sie die Aktion.`;
    case 404:
      return "Leider wurde die Seite nicht gefunden.";
    case 500:
      return "Leider ist ein interner Server-Fehler aufgetreten.";
    default:
      return "Entschuldigung, ein Fehler ist aufgetreten.";
  }
};

export const mapLoginError = (response: {
  status: number,
  data: { error?: typeof ACCOUNT_LOCKED | typeof UNAUTHORIZED_SCOPE | typeof ACCOUNT_UNCONFIRMED }
}) => {
  const { status, data } = response;

  return (status === 403 && data.error && autorizationErrors[data.error]) || statusErrors(status);
};

export default statusErrors;
